import { Form, Modal } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { GET, StepForm, mrs } from 'utils';
import { api } from 'utils/apiRoutes';
import { CustomInput } from '../../custom';
import CustomDatePicker from '../../custom/CustomDatePicker';
import Options from './Options';
import SubmitButton from './SubmitButton';
const { Item } = Form;
const Three: React.FC<StepForm> = ({ form_data, onSubmit, onBack }) => {
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const navigate = useNavigate();
  const [state, setState] = useState({
    managerList: [],
    serviceList: [],
    open: false,
    textPopup: '',
    okType: '',
    department_id: 0,
  });
  const { managerList, serviceList, open, textPopup, okType, department_id } =
    state;
  const departmentData = useQuery('get-derpatment-list', async () => {
    return await GET(api.departmentList);
  });
  const departmentList = departmentData?.data?.data.map((item: object) => ({
    label: item['name'],
    value: item['id'],
  }));

  const hasAccents = /[áéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôÂÊÎÔãõÃÕ]/;

  const isValidEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const validateEmail = (rule, value, callback) => {
    if (value?.length === 0 || !value) {
      callback('Email is required');
    }

    const isValidAccents = hasAccents.test(value);

    // Email validation regex
    const isEmail = isValidEmail.test(value);
    if (value && (isValidAccents || !isEmail)) {
      callback('Invalid email address');
    } else {
      callback(); // Pass validation
    }
  };

  const onSelectDepartment = (id: number) => {
    setState((p) => ({
      ...p,
      serviceList: [],
      managerList: [],
    }));
    form.setFieldValue('service_id', null);
    form.setFieldValue('manager_ids', null);
    if (form_data['role'] === 'department_manager') {
      GET(
        `${api.managerList}?department_id=${+id}&role=department_manager`,
      ).then((res) => {
        if (!res?.data?.default_manager) {
          setState((p) => ({
            ...p,
            open: true,
            textPopup:
              'This department already has manager, please choose another department.',
          }));
          form.setFieldValue('department_id', null);
        }
      });
    } else {
      setState((p) => ({ ...p, department_id: id }));
      GET(`${api.getService}?department_id=${id}`)
        .then((res) => {
          if (res.data.length === 0) {
            setState((p) => ({
              ...p,
              open: true,
              textPopup:
                'This department does not have a service yet, you need to create a service first or choose another department.',
              okType: 'not_service',
            }));
          } else {
            setState((p) => ({
              ...p,
              serviceList: res?.data?.map((item: object) => ({
                label: item['name'],
                value: item['id'],
              })),
            }));
          }
        })
        .catch((e) => console.error(e));
    }
  };
  const onSelectService = async (id: number) => {
    setState((p) => ({
      ...p,
      managerList: [],
    }));
    form.setFieldValue('manager_ids', null);

    if (form_data['role'] === 'service_manager') {
      await GET(
        `${api.managerList}?role=service_manager&service_id=${id}`,
      ).then((res) => {
        const hasManager = res?.data?.results.find(
          (item: { role: string }) => item.role === 'service_manager',
        );

        if (hasManager) {
          setState((p) => ({
            ...p,
            open: true,
            textPopup:
              'This service already has manager, please choose another service.',
          }));
          form.setFieldValue('service_id', null);
        } else {
          GET(
            `${api.managerList}?role=department_manager&department_id=${department_id}`,
          ).then((res) => {
            setState((p) => ({
              ...p,
              managerList: res?.data?.results
                .filter(
                  (item) =>
                    (res?.data?.default_manager === false &&
                      item.role === 'department_manager') ||
                    (res?.data?.default_manager === true &&
                      item.role === 'admin'),
                )
                .map((item: object) => ({
                  label: `${item['first_name']} ${item['last_name']}`,
                  value: item['id'],
                })),
            }));
          });
        }
      });

      return;
    }
    if (form_data['role'] === 'employee') {
      await GET(`${api.managerList}?role=employee&service_id=${id}`)
        .then((res) =>
          setState((p) => ({
            ...p,
            managerList: res.data?.results?.map((item: object) => ({
              label: `${item['first_name']} ${item['last_name']}`,
              value: item['id'],
            })),
          })),
        )
        .catch((e) => console.error(e));
    } else {
      await GET(`${api.managerList}?role=service_manager&service_id=${id}`)
        .then((res) =>
          setState((p) => ({
            ...p,
            managerList: res.data.results
              .filter(
                (item: { role: string }) =>
                  (res?.data?.default_manager === false &&
                    item.role === 'department_manager') ||
                  (res?.data?.default_manager === true &&
                    item.role === 'admin') ||
                  (res?.data?.default_manager === false &&
                    item.role === 'service_manager'),
              )
              .map((item: object) => ({
                label: `${item['first_name']} ${item['last_name']}`,
                value: item['id'],
              })),
          })),
        )
        .catch((e) => console.error(e));
    }
  };

  useEffect(() => {
    if (form_data['department_id']) {
      GET(`${api.getService}?department_id=${form_data['department_id']}`)
        .then((res) =>
          setState((p) => ({
            ...p,
            serviceList: res.data.map((item: object) => ({
              label: item['name'],
              value: item['id'],
            })),
          })),
        )
        .catch((e) => console.error(e));
    }
    if (form_data['service_id']) {
      GET(
        `${api.managerList}?role=${form_data['role']}&service_id=${form_data['service_id']}`,
      )
        .then((res) =>
          setState((p) => ({
            ...p,
            managerList: res.data.results.map((item: object) => ({
              label: `${item['first_name']} ${item['last_name']}`,
              value: item['id'],
            })),
          })),
        )
        .catch((e) => console.error(e));
    }
  }, [form_data]);

  return (
    <>
      <Form
        initialValues={{
          ...form_data,
          contract_start_date:
            dayjs(form_data['contract_start_date']) || dayjs(),
        }}
        form={form}
        onFinish={(v) =>
          onSubmit({
            ...v,
            contract_start_date: v['contract_start_date'].format('YYYY-MM-DD'),
            manager_ids:
              form_data['role'] === 'department_manager'
                ? [1]
                : v['manager_ids'],
          })
        }
      >
        <div className={'form-wrapper'}>
          <h1 className="form-wrapper_title">Future Employee</h1>
          <div
            className="is-flex"
            style={{
              gap: 32,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
            }}
          >
            <Options
              rule={[{ required: true, message: 'Title is required' }]}
              name="title"
              options={mrs}
              height="50px"
              required
              title={'Gender'}
              width={'100%'}
            />

            <Item
              name={'last_name'}
              rules={[{ required: true, message: 'Last Name is required' }]}
              style={{ width: '100%' }}
            >
              <CustomInput
                maxLength={50}
                title={'Last Name'}
                height="50px"
                fontSize={12}
                required
                width={'100%'}
              />
            </Item>
            <Item
              name={'first_name'}
              rules={[{ required: true, message: 'First Name is required' }]}
              style={{ width: '100%' }}
            >
              <CustomInput
                maxLength={50}
                title={'First Name'}
                height="50px"
                fontSize={12}
                required
                width={'100%'}
              />
            </Item>
          </div>
          <Item
            name={'contract_start_date'}
            rules={[
              { required: true, message: 'Contract Start Date is required' },
            ]}
          >
            <CustomDatePicker
              height="50px"
              fontSize={12}
              borderRadius={6}
              title={'Contract Start Date'}
              required
            />
          </Item>
          <Item
            name={'email'}
            rules={[
              {
                validator: validateEmail,
              },
            ]}
          >
            <CustomInput
              height="50px"
              fontSize={12}
              error={
                form.getFieldValue('email')?.length > 0 &&
                (hasAccents.test(form.getFieldValue('email')) ||
                  !isValidEmail.test(form.getFieldValue('email')))
              }
              required
              onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                const allowedChars = /^[a-zA-Z0-9@_.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }
              }}
              title={'Email Address'}
              width={'100%'}
            />
          </Item>
          <div className="is-flex" style={{ gap: 24, marginBottom: 24 }}>
            <div style={{ width: '55%' }}>
              <Options
                name="department_id"
                rule={[{ required: true, message: 'Department is required' }]}
                options={departmentList}
                onChange={onSelectDepartment}
                required
                height="50px"
                title={'Department'}
              />
            </div>
            <div style={{ width: '55%' }}>
              {form_data['role'] !== 'department_manager' && (
                <Options
                  name="service_id"
                  rule={[
                    {
                      required: form_data['role'] !== 'department_manager',
                      message: 'Service is required',
                    },
                  ]}
                  options={serviceList}
                  required
                  height="50px"
                  onChange={onSelectService}
                  title={'Service'}
                  disabled={
                    serviceList.length === 0 ||
                    form_data['role'] === 'department_manager'
                  }
                />
              )}
            </div>
          </div>
          <div style={{ width: '49.35%' }} className="pb-4">
            {form_data['role'] !== 'department_manager' && (
              <Options
                name="manager_ids"
                rule={[
                  {
                    required: form_data['role'] !== 'department_manager',
                    message: 'Supervisor is required',
                  },
                ]}
                options={managerList}
                required
                height="50px"
                disabled={
                  managerList.length === 0 ||
                  form_data['role'] === 'department_manager'
                }
                title={'Supervisor'}
                onChange={(v) => form.setFieldValue('manager_ids', [v])}
              />
            )}
          </div>
        </div>
        <div className="is-pulled-right my-4 is-flex">
          <button
            className={
              'add_user_button  is-flex is-justify-content-center is-align-items-center  mr-3'
            }
            onClick={() => onBack(values)}
          >
            <img src="/icons/next_button.svg" alt="next" />
            <span>BACK</span>
          </button>
          <Item>
            <SubmitButton form={form} />
          </Item>
        </div>
      </Form>
      <Modal
        centered
        open={open}
        onOk={() =>
          okType === 'not_service'
            ? navigate('/general_settings/departments')
            : setState((p) => ({ ...p, open: false }))
        }
        onCancel={() => setState((p) => ({ ...p, open: false }))}
      >
        <p>{textPopup}</p>
      </Modal>
    </>
  );
};
export default Three;
